import React from 'react';

import {
  FeatureFlagsContext,
  FeatureFlagsContextType,
  isIntegratorsFeatureFlag,
} from '@/context/featureFlagsContext';
import { useCustomer } from '@/hooks/useCustomer';

export function useGlobalFeatureFlag(flagKey: string, defaultValue: boolean = false): boolean {
  const context = React.useContext<FeatureFlagsContextType | undefined>(FeatureFlagsContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }
  const { getFlag } = context;

  const value = getFlag(flagKey, false);
  if (!value) {
    return defaultValue;
  } else if (typeof value === 'boolean') {
    return value;
  } else {
    console.warn(`Flag ${flagKey} is not a boolean`, value);
    return defaultValue;
  }
}

export function useIntegratorFeatureFlag(flagKey: string, defaultValue: boolean = false): boolean {
  const customer = useCustomer();

  const context = React.useContext<FeatureFlagsContextType | undefined>(FeatureFlagsContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }
  const { getFlag } = context;

  const value = getFlag(flagKey, { integrators: [] });
  if (!value || !customer.keycloakId) {
    return defaultValue;
  } else if (typeof value === 'boolean') {
    console.warn(`Flag ${flagKey} is not a user flag: ${value}`);
    return defaultValue;
  } else if (isIntegratorsFeatureFlag(value)) {
    const { integrators } = value;
    if (!customer.integratorId) {
      return defaultValue;
    }

    // Support wildcard '*' to enable for all integrators
    if (integrators.includes('*') || integrators.includes(customer.integratorId)) {
      return true;
    }
    return defaultValue;
  } else {
    return defaultValue;
  }
}
